"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addToBasketHandler = addToBasketHandler;
var _utils = require("../utils");
async function addToBasketHandler({
  detail: {
    itemCode,
    quantity,
    originalItemCode,
    replacementType,
    method: addToBasketMethod,
    placement
  }
}) {
  const {
    url,
    method
  } = (0, _utils.getBuyingUrlAndMethod)(addToBasketMethod);
  return (0, _utils.addToBasket)(url, {
    itemCode,
    quantity,
    originalItemCode,
    replacementType,
    placement
  }, method);
}